import React, { useState, useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import { Button, Container, Title, View } from '@common/components';
import { Row, Col, Layout } from 'antd';
import { Helmet } from 'react-helmet';
import { fetchOrganization } from '@common/resources/Organization/actions';
import {
	fetchStocks,
	fetchStocksByOrganization,
	clearStocks,
} from '@resources/Stock/actions';
import { FormattedMessage, useIntl } from 'react-intl';
import { OrderItem } from '@fragments/items';
import CreateModal from './Create';
import UpdateModal from './Update';

const { Content } = Layout;

const Order = (props) => {
	const {
		stocks,
		fetchStocks,
		fetchStocksByOrganization,
		clearStocks,
		organization,
	} = props;
	const intl = useIntl();
	const [create, setCreate] = useState(false);
	const [update, setUpdate] = useState(false);

	useEffect(() => {
		const func = async () => {
			await clearStocks();

			organization?._id
				? await fetchStocksByOrganization(organization?._id)
				: await fetchStocks();
		};

		func();
	}, [fetchStocks, fetchStocksByOrganization, clearStocks, organization]);

	const parseDataSource = useCallback(() => {
		return stocks.map((stock) => {
			return {
				key: stock._id,
				...stock,
			};
		});
	}, [stocks]);

	return (
		<Content>
			<Helmet>
				<title>
					{intl.formatMessage({
						id: 'common.order.management',
						defaultMessage: 'Order Management',
					})}
				</title>
			</Helmet>
			<CreateModal
				{...props}
				module={module}
				visible={create}
				onCancel={() => setCreate(false)}
			/>

			<UpdateModal
				{...props}
				module={module}
				visible={update}
				onCancel={() => setUpdate(false)}
			/>
			<Container>
				<View>
					<Row
						type="flex"
						justify="center"
						align="middle"
						className="mt-5">
						<Col md={{ span: 12 }}>
							<Title>
								<FormattedMessage
									id="common.orders"
									defaultMessage="Orders"
								/>
							</Title>
						</Col>
						<Col md={{ span: 12 }} className="text-right">
							<Button
								type="primary"
								onClick={() => setCreate(true)}>
								<FormattedMessage
									id="common.new.order"
									defaultMessage="New Order"
								/>
							</Button>
						</Col>
					</Row>
					{parseDataSource() &&
						parseDataSource().map((stock, index) => (
							<OrderItem
								key={`stock-${index}`}
								stock={stock}
								onEdit={() => setUpdate(stock._id)}
							/>
						))}
				</View>
			</Container>
		</Content>
	);
};

const mapStateToProps = ({
	stocks,
	modules,
	cellGroup,
	event,
	facility,
	ministry,
	mission,
	organization,
	prayer,
	testimony,
	service,
}) => {
	return {
		stocks,
		modules,
		cellGroup,
		event,
		facility,
		ministry,
		mission,
		organization,
		prayer,
		testimony,
		service,
	};
};

export default connect(mapStateToProps, {
	fetchOrganization,
	fetchStocks,
	fetchStocksByOrganization,
	clearStocks,
})(Order);
